import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, Send } from "lucide-react";
import { resendActivation } from "../../api/platform";
import { NeuButton } from "../../components/neu/Neu";

const COOLDOWN = 120;

export const CompanyActivationButton = ({ company, reload }) => {
  const { t } = useTranslation();
  const [state, setState] = useState("idle");
  const [reason, setReason] = useState("");
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (left <= 0) return undefined;
    const timer = setTimeout(() => setLeft((value) => value - 1), 1000);
    return () => clearTimeout(timer);
  }, [left]);

  if (!company.needs_activation) return null;

  const resend = async () => {
    setState("sending");
    try {
      await resendActivation(company.id);
      setState("sent");
      setLeft(COOLDOWN);
      reload();
    } catch (error) {
      setReason(error?.response?.data?.detail || "");
      setState("failed");
    }
  };

  const clock = `${String(Math.floor(left / 60)).padStart(2, "0")}:${String(left % 60).padStart(2, "0")}`;
  const label =
    state === "sending"
      ? t("activation.sending")
      : left > 0
        ? `${t("activation.sent")} · ${clock}`
        : state === "failed"
          ? `${t("activation.failed")}${reason ? `: ${reason}` : ""}`
          : t("activation.resend");

  return (
    <NeuButton
      variant={state === "failed" ? "danger" : "primary"}
      className="flex items-center gap-2 disabled:opacity-60"
      data-testid={`company-resend-activation-${company.id}`}
      disabled={state === "sending" || left > 0}
      onClick={resend}
    >
      {left > 0 ? <Check className="h-4 w-4" /> : <Send className="h-4 w-4" />}
      <span className="num">{label}</span>
    </NeuButton>
  );
};
